import get from 'lodash.get';

const getStatus = (state) => get(state, 'ws.saving.status', null);
export default getStatus;
